{
  "title": "UI kit",
  "intro": "Every bPanel App component on one page, in both directions. Text follows the current language; each column's direction is fixed.",
  "direction": {
    "label": "Direction",
    "both": "Both"
  },
  "dirLabel": {
    "rtl": "Right to left",
    "ltr": "Left to right"
  },
  "latency": {
    "normal": "Normal latency",
    "fast": "Low latency",
    "slow": "High latency",
    "off": "No latency"
  },
  "sections": {
    "buttons": "Buttons",
    "forms": "Fields and forms",
    "surfaces": "Surfaces and headers",
    "status": "States and alerts",
    "data": "Data and usage",
    "table": "Tables",
    "feedback": "Empty states and errors",
    "overlays": "Dialogs and menus",
    "flows": "Steps and commands",
    "plans": "Plans and prices",
    "mock": "Demo mode tools"
  },
  "table": {
    "server": "Server",
    "hostname": "Hostname",
    "plan": "Plan",
    "search": "Search by name or hostname"
  },
  "samples": {
    "addServer": "Add a server",
    "email": "Email",
    "emailHint": "We send invoices and alerts here.",
    "hostname": "Hostname",
    "hostnameError": "Enter a full hostname, like server1.example.sa",
    "password": "Password",
    "country": "Country",
    "server": "Server",
    "message": "Message",
    "messagePlaceholder": "Describe the problem briefly",
    "checkbox": "Send a copy of each invoice to the billing team",
    "checkboxHint": "They get an email with every new invoice.",
    "switch": "Auto top-up for AI credits",
    "switchHint": "We add 100 credits when the balance runs low.",
    "os": "Operating system",
    "osRecommended": "Recommended",
    "serverName": "Riyadh 1",
    "servers": "Servers",
    "pageDescription": "server1.example.sa on Pro, billed yearly.",
    "panelTitle": "Activation key and updates",
    "panelDescription": "Everything about this server's subscription.",
    "panelFooter": "Last check-in 2 minutes ago.",
    "tabs": {
      "overview": "Overview",
      "overviewBody": "The server is connected and running, and every site is working as usual.",
      "updates": "Updates",
      "updatesBody": "Version 1.5.0 is available on the beta channel."
    },
    "healthy": "Running",
    "attention": "Needs attention",
    "failed": "Failed",
    "alerts": {
      "infoTitle": "Version 1.4.2 is available",
      "infoBody": "Update the server to get the latest fixes.",
      "successTitle": "Billing details saved",
      "warningTitle": "Hosting accounts are close to the limit",
      "warningBody": "87 of 100 accounts used on server2.example.sa.",
      "dangerTitle": "A payment failed",
      "dangerBody": "Update your payment method so you can keep adding accounts."
    },
    "payNow": "Pay now",
    "bannerTrial": "5 days left in your free trial. Set up payment so your servers keep running.",
    "stats": {
      "servers": "Servers",
      "serversHint": "3 running, 1 awaiting payment",
      "renewal": "Next renewal",
      "credits": "AI credits left"
    },
    "chart": "AI credit usage, last 6 months",
    "months": {
      "may": "May",
      "jun": "Jun",
      "jul": "Jul",
      "aug": "Aug",
      "sep": "Sep",
      "oct": "Oct"
    },
    "version": "Version",
    "versionHint": "Stable channel",
    "price": "Price",
    "timeline": {
      "activated": "Server activated",
      "installed": "Install finished",
      "created": "You added the server"
    },
    "empty": {
      "title": "You haven't added a server yet",
      "body": "Add your first server and install bPanel on it with one command."
    },
    "toasts": {
      "success": "Success",
      "info": "Info",
      "warning": "Warning",
      "error": "Error",
      "saved": "Saved",
      "copied": "Hostname copied"
    },
    "openDialog": "Dialog",
    "openConfirm": "Confirm delete",
    "openDrawer": "Drawer",
    "invite": "Invite a member",
    "tooltip": "A short hint about this button",
    "hoverMe": "Hover here",
    "dialog": {
      "title": "Rename server",
      "body": "Only you and your team see this name."
    },
    "serverNameLabel": "Server name",
    "confirm": {
      "title": "Cancel this server's subscription?",
      "body": "The subscription runs until the end of the paid period, then the control panel locks, with no refund for the time left. Sites, mail and databases keep running.",
      "action": "Cancel subscription"
    },
    "drawer": {
      "title": "Server details",
      "body": "A quick summary without leaving the page."
    },
    "steps": {
      "plan": "Choose a plan",
      "install": "Install bPanel",
      "installHint": "Run the commands on the server",
      "activate": "Activate the server"
    },
    "installationId": "Installation id"
  },
  "mock": {
    "body": "Try the hard cases: when the session expires, the sign-in dialog opens and you stay on the page.",
    "expire": "Expire the session now",
    "signInFirst": "Sign in with a demo account first."
  }
}
